import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=542de9d0"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports